import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  color = 'primary',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  const colorClasses = {
    primary: 'border-primary-500',
    secondary: 'border-gray-500',
    success: 'border-success-500',
    warning: 'border-warning-500',
    danger: 'border-danger-500'
  };

  return (
    <div className={`inline-block ${sizeClasses[size]} ${className}`}>
      <div className={`${sizeClasses[size]} border-2 border-gray-200 dark:border-gray-700 ${colorClasses[color]} border-t-transparent rounded-full animate-spin`} />
    </div>
  );
};

export { LoadingSpinner };
export default LoadingSpinner;